export default __webpack_public_path__ + "static/media/cancel.85d9c86c.svg";